import React from 'react';

export const TableHeader = () => (
    <thead className="kt-datatable__head">
    <tr className="kt-datatable__row">
        <th width="40px" className="kt-datatable__cell"><span>ID</span></th>
        <th width="300px" className="kt-datatable__cell"><span>Название</span></th>
        <th style={{textAlign: 'right'}} width="180px" className="kt-datatable__cell"><span>Действия</span></th>
    </tr>
    </thead>
);